import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import uflowIcon from '../../../pic/uflowIcon.png';
import { useTranslation } from 'react-i18next';

function Header({ fixed }) {
    const { t } = useTranslation();
    return (
        <header className={`header ${fixed ? 'header-fixed' : ''}`}>
            <div className="logo">
                <img src={uflowIcon} alt="UFLOW Logo" />
                <span>UFLOW</span>
            </div>
            <nav>
                <ul>
                    <li><Link to="/">{t('header.home')}</Link></li>
                    {/* <li><Link to="/contact">Contact Us</Link></li> */}
                    <li><Link to="/login">{t('header.login')}</Link></li>
                    {/* <li><Link to="/about">About us</Link></li> */}
                </ul>
            </nav>
        </header>
    );
}

export default Header;
